import {Component} from '@angular/core';

@Component({
  selector: 'lm-nx-frontend-spinner',
  template: `<mat-progress-spinner mode="indeterminate"></mat-progress-spinner>`
})
export class SpinnerComponent {
}
